import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMontenegro = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1247)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 7.88152 21.9249 4.24805 18.7635 2.08698H5.23655C2.07516 4.24805 0 7.88152 0 12C0 16.1186 2.07516 19.752 5.23655 21.913H18.7635C21.9249 19.752 24 16.1186 24 12Z",
				fill: "#A2001D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.39133 8.86954H14.6087V6.78262L13.5652 7.30434L12 5.73914L10.4348 7.30434L9.39133 6.78262V8.86954Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.6957 12H14.088C14.1902 11.8231 14.2497 11.6184 14.2497 11.3994C14.2497 10.7344 13.7106 10.1953 13.0457 10.1953C12.5862 10.1953 12.1872 10.4528 11.9842 10.8311C11.7812 10.4527 11.3822 10.1953 10.9228 10.1953C10.2579 10.1953 9.71874 10.7344 9.71874 11.3994C9.71874 11.6184 9.77828 11.8231 9.88046 12H7.30426C7.30426 12.7979 7.99928 13.4448 8.79718 13.4448H8.74909C8.74909 14.0993 9.18442 14.6519 9.78128 14.8295L8.6086 16.0022L9.71537 17.109L11.2854 15.539C11.3469 15.5615 11.4105 15.5795 11.4762 15.5919L10.5276 17.7339C10.9822 17.9187 11.479 18.0214 12 18.0214C12.521 18.0214 13.0178 17.9187 13.4724 17.7339L12.5238 15.5919C12.5895 15.5796 12.6531 15.5615 12.7146 15.539L14.2846 17.109L15.3913 16.0022L14.2186 14.8295C14.8154 14.6519 15.2507 14.0993 15.2507 13.4448H15.2026C16.0006 13.4448 16.6957 12.7979 16.6957 12Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 12.7826L10.3044 13.5652V15.1305L12 16.1739L13.6957 15.1305V13.5652L12 12.7826Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.3044 12H13.6957V14.087H10.3044V12Z",
				fill: "#0052B4"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1247",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgMontenegro;
